import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {showAlertMessage} from "../../../modules/alert";
import {showToastMessage} from "../../../modules/toast";
import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/functions';

import TrafficConditionActionSheet from './trafficConditionActionSheet';
import ShareActionSheet from './shareActionSheet';
import TargetNaverPlaceActionSheet from './targetNaverPlaceActionSheet';
import {hideLoaderMessage, showLoaderMessage} from "../../../modules/loader";
import {CHECK_ANONYMOUS, OPEN_EXTERNAL_LINK} from "../../../modules/variable/common_variable";
import {showTutorial} from "../../../modules/tutorial";

class TargetScheduleActionSheetFunctions extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});
        //this.scheduleSupplementRef = firebase.firestore().collection('user_schedule_supplement');

        this.state = {
            targetScheduleActionSheet: {open: false, title: '', data: null, polyLine: [], mapCenter: {lat: 37.554690, lng: 126.970702}, targetToMapCenter: null},
            targetNaverPlaceActionSheet: {targetMarker: null, open: false, isLoading: false, data: null},
            trafficConditionActionSheet: {open: false, list: []},
            shareActionSheet: {open: false},
            isAddedFavorite: false,
            operationSystem: null
        };
    }

    componentDidMount(){
        this.setState({targetScheduleActionSheet: this.props.TSAS});

        if(this.checkIsAddedFavorite(this.props.TSAS.data.DOC_ID)){
            this.setState({isAddedFavorite: true})
        }

        try {
            const md = new window.MobileDetect(window.navigator.userAgent);
            this.setState({operationSystem: md.os() ? md.os() : 'PC'});
        } catch (e) {
            console.error(e);
        }

        if(!localStorage.getItem('CONFIRMED_TUTORIAL_SCHEDULE_VIEW')){
            this.props.showTutorial('SCHEDULE_VIEW');
            localStorage.setItem('CONFIRMED_TUTORIAL_SCHEDULE_VIEW', "true");
        }
    }

    componentWillReceiveProps(nextProps) {
        if(JSON.stringify(this.state.targetNaverPlaceActionSheet) !== JSON.stringify(nextProps.TSAS.targetNaverPlaceActionSheet)){
            this.setState({targetNaverPlaceActionSheet: nextProps.TSAS.targetNaverPlaceActionSheet})
        }
    }

    /*chooseNaverPlace = (marker) => {
        //console.log(marker);
        this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, targetMarker: marker, open: true, isLoading: false, data: null}});
    };*/

    recommendSchedule = (DOC_ID) => {
        this.props.showLoaderMessage("추천중입니다.");
        const savedRecommendSchedule = localStorage.getItem('savedRecommendSchedule');
        let parsedRecommendSchedule = [];
        if(savedRecommendSchedule){
            try {
                parsedRecommendSchedule = JSON.parse(savedRecommendSchedule);
                if(parsedRecommendSchedule.indexOf(DOC_ID) !== -1){
                    this.props.showToastMessage('이미 추천한 일정입니다.');
                    this.props.hideLoaderMessage();
                    return;
                }
            } catch (e) {console.error(e)}
        }

        const recommendSchedule = firebase.functions().httpsCallable('recommendSchedule');
        recommendSchedule({uid: this.props.userInfo.uid, DOC_ID: DOC_ID}).then((result) => {
            if(result.data.result === 'success'){
                /*let rl = this.state.recommendList;
                for(let i = 0; i < rl.list.length; i ++){
                    if(DOC_ID === rl.list[i]['DOC_ID']){
                        rl.list[i].recommend = parseInt(rl.list[i].recommend) + 1;
                    }
                }
                this.setState({recommendList: rl});*/
                const data = this.state.targetScheduleActionSheet.data;
                data.recommend = Number(data.recommend) + 1;
                this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, data: data}});
                this.props.showToastMessage('해당 일정을 추천하였습니다. 리스트에는 추후에 반영됩니다.');

                parsedRecommendSchedule.push(DOC_ID);
                localStorage.setItem('savedRecommendSchedule', JSON.stringify(parsedRecommendSchedule));
            }else{
                switch (result.data.message.name){
                    case 'ALREADY_EXISTED':
                        this.props.showToastMessage('이미 추천한 일정입니다.');
                        break;
                    default:
                        this.props.showToastMessage('추천 과정에서 문제가 발생하였습니다.');
                }
            }
            this.props.hideLoaderMessage();
        });
    };

    addFavoriteSchedule = (target) => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        if(this.checkIsAddedFavorite(target.DOC_ID)){
            this.props.showToastMessage('이미 추가한 즐겨찾기입니다.');
            return;
        }

        this.props.showLoaderMessage("즐겨찾기에 추가중입니다.");
        const favoriteJson = {docId: target.DOC_ID, title: target.title, nickname: target.nickname, uid: target.uid, imageSrc: target.schedule[target.scheduleOrder[target.thumbnailIndex ? target.thumbnailIndex : 0]].imageSrc, representative: target.representative, date: new Date().valueOf(), use: true};
        firebase.firestore().collection('user_supplement').doc(this.props.userInfo.uid).collection("favorite").doc(target.DOC_ID).set(favoriteJson).then(() => {
            try {
                this.props.showToastMessage('즐겨찾기에 추가하였습니다.');
                this.props.hideLoaderMessage();
                this.setState({isAddedFavorite: true});
                let parsedFavoriteSchedule = localStorage.getItem('savedFavoriteSchedule') ? JSON.parse(localStorage.getItem('savedFavoriteSchedule')) : [];
                parsedFavoriteSchedule.push(target.DOC_ID);
                localStorage.setItem('savedFavoriteSchedule', JSON.stringify(parsedFavoriteSchedule));
            } catch (e) {console.error(e)}
        }).catch((error) => {
            console.error(error);
            this.props.showToastMessage('즐겨찾기 추가 과정에서 문제가 발생하였습니다.');
            this.props.hideLoaderMessage();
        });
    };

    checkIsAddedFavorite = (DOC_ID) => {
        let isAddedFavorite = false;
        const savedFavoriteSchedule = localStorage.getItem('savedFavoriteSchedule');
        let parsedFavoriteSchedule = [];
        if(savedFavoriteSchedule){
            try {
                parsedFavoriteSchedule = JSON.parse(savedFavoriteSchedule);
                if(parsedFavoriteSchedule.indexOf(DOC_ID) !== -1){
                    isAddedFavorite = true;
                }
            } catch (e) {console.error(e)}
        }
        return isAddedFavorite;
    };

    showTrafficConditionActionSheet = (data) => {
        //console.log(data);

        let list = [];

        data.scheduleOrder.map((key) => {
            list.push(data.schedule[key]);
        });
        this.setState({trafficConditionActionSheet: {open: true, list: list}});
    };

    goToCopySchedule = (data) => {
        this.props.history.push({
            pathname: '/copySchedule',
            state: {data: data}
        });
    };

    goToEditSchedule = (data) => {
        this.props.history.push({
            pathname: '/editSchedule',
            state: {data: data}
        });
    };

    render() {
        const TSAS = this.state.targetScheduleActionSheet;

        if(!TSAS || !TSAS.data){
            return <div/>
        }

        return (
            <div>
                {
                    !this.props.hideTabBar || this.props.hideTabBar === false ?
                        <div className="text-center target-schedule-tabbar-wrapper">
                            <div className="tabbar tabbar--top tabbar--material">
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" style={{color: '#fc2e5a'}} disabled={!this.props.userInfo.isSignedIn} onClick={() => this.recommendSchedule(TSAS.data.DOC_ID)}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-heart"/>
                                        <div className="tabbar__label tabbar--material__label">좋아요 {TSAS.data.recommend}</div>
                                    </button>
                                </label>
                                {
                                    this.props.userInfo.isAnonymous ?
                                        <label className="tabbar__item tabbar--material__item">
                                            <button className="tabbar__button tabbar--material__button" style={{color: '#FFEB3B', opacity: 0.3}} onClick={() => this.props.showToastMessage('체험하는 동안에는 즐겨찾기에 추가할 수 없습니다.')}>
                                                <i className="tabbar__icon tabbar--material__icon fa fa-star"/>
                                                <div className="tabbar__label tabbar--material__label">즐겨찾기</div>
                                            </button>
                                        </label>
                                        :
                                        this.state.isAddedFavorite ?
                                            <label className="tabbar__item tabbar--material__item">
                                                <button className="tabbar__button tabbar--material__button" style={{color: '#FFEB3B'}} disabled={!this.props.userInfo.isSignedIn} onClick={() => this.addFavoriteSchedule(TSAS.data)}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-star"/>
                                                    <div className="tabbar__label tabbar--material__label">추가됨</div>
                                                </button>
                                            </label>
                                            :
                                            <label className="tabbar__item tabbar--material__item">
                                                <button className="tabbar__button tabbar--material__button" style={{color: '#FFEB3B'}} onClick={() => this.addFavoriteSchedule(TSAS.data)}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-star"/>
                                                    <div className="tabbar__label tabbar--material__label">즐겨찾기</div>
                                                </button>
                                            </label>
                                }
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.props.showTutorial('SCHEDULE_VIEW')}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-question"/>
                                        <div className="tabbar__label tabbar--material__label">도움말</div>
                                    </button>
                                </label>
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button TUTO_SHARE_BUTTON" onClick={() => this.setState({shareActionSheet: {...this.state.shareActionSheet, open: true}})}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-share-alt"/>
                                        <div className="tabbar__label tabbar--material__label">공유하기</div>
                                    </button>
                                </label>
                                {
                                    !this.props.userInfo.isAnonymous ?
                                        TSAS.data.edit ?
                                            TSAS.data.uid === this.props.userInfo.uid ?
                                                <label className="tabbar__item tabbar--material__item">
                                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.goToEditSchedule(TSAS.data)}>
                                                        <i className="tabbar__icon tabbar--material__icon fa fa-edit"/>
                                                        <div className="tabbar__label tabbar--material__label">수정하기</div>
                                                    </button>
                                                </label>
                                                :
                                                <label className="tabbar__item tabbar--material__item">
                                                    <button className="tabbar__button tabbar--material__button" onClick={() => this.goToCopySchedule(TSAS.data)}>
                                                        <i className="tabbar__icon tabbar--material__icon fa fa-copy"/>
                                                        <div className="tabbar__label tabbar--material__label">복사하기</div>
                                                    </button>
                                                </label>
                                            :
                                            <label className="tabbar__item tabbar--material__item">
                                                <button className="tabbar__button tabbar--material__button" style={{opacity: 0.3}} onClick={() => this.props.showAlertMessage([TSAS.data.nickname + "님이 복사를 허용하지 않았습니다."].join(''), "복사 불가")}>
                                                    <i className="tabbar__icon tabbar--material__icon fa fa-copy"/>
                                                    <div className="tabbar__label tabbar--material__label">복사하기</div>
                                                </button>
                                            </label>
                                        :
                                        null
                                }
                                <label className="tabbar__item tabbar--material__item">
                                    <button className="tabbar__button tabbar--material__button TUTO_TRAFFIC_CONDITION_BUTTON" style={{color: '#5ea000'}} onClick={() => this.showTrafficConditionActionSheet(TSAS.data)}>
                                        <i className="tabbar__icon tabbar--material__icon fa fa-road"/>
                                        <div className="tabbar__label tabbar--material__label">교통</div>
                                    </button>
                                </label>
                                {
                                    this.props.userInfo.isAnonymous && this.props.isolated ?
                                        !window.isRNWebView && !window.isETView ?
                                            this.state.operationSystem === 'iOS'?
                                                <label className="tabbar__item tabbar--material__item" onClick={() => OPEN_EXTERNAL_LINK('https://itunes.apple.com/kr/app//id1453041236?mt=8')}>
                                                    <button className="tabbar__button tabbar--material__button" style={{color: '#3f51b5'}}>
                                                        <i className="tabbar__icon tabbar--material__icon fa fa-apple"/>
                                                        <div className="tabbar__label tabbar--material__label">앱설치</div>
                                                    </button>
                                                </label>
                                                :
                                                this.state.operationSystem === 'AndroidOS' ?
                                                    <label className="tabbar__item tabbar--material__item" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.hopse.picnici")}>
                                                        <button className="tabbar__button tabbar--material__button" style={{color: '#3f51b5'}}>
                                                            <i className="tabbar__icon tabbar--material__icon fa fa-android"/>
                                                            <div className="tabbar__label tabbar--material__label">앱설치</div>
                                                        </button>
                                                    </label>
                                                    :
                                                    this.state.operationSystem === 'PC' ?
                                                        <label className="tabbar__item tabbar--material__item" onClick={() => window.open("https://firebasestorage.googleapis.com/v0/b/picnici.appspot.com/o/PICNICI_Setup_1.0.0.exe?alt=media&token=f717c972-697d-406a-8dba-dbe638cbeb6d")}>
                                                            <button className="tabbar__button tabbar--material__button" style={{color: '#3f51b5'}}>
                                                                <i className="tabbar__icon tabbar--material__icon fa fa-laptop"/>
                                                                <div className="tabbar__label tabbar--material__label">앱설치</div>
                                                            </button>
                                                        </label>
                                                        :
                                                        null
                                            :
                                            null
                                        :
                                        null
                                }
                                {
                                    this.props.userInfo.isAnonymous && this.props.isolated ?
                                        <label className="tabbar__item tabbar--material__item">
                                            <button className="tabbar__button tabbar--material__button" onClick={() => this.props.history.push('/home')}>
                                                <i className="tabbar__icon tabbar--material__icon ion-ios-home"/>
                                                <div className="tabbar__label tabbar--material__label">홈으로</div>
                                            </button>
                                        </label>
                                        :
                                        null
                                }
                            </div>
                        </div>

                        :
                        null
                }

                {
                    this.state.targetNaverPlaceActionSheet && this.state.targetNaverPlaceActionSheet.open ?
                        <TargetNaverPlaceActionSheet targetNaverPlaceActionSheet={this.state.targetNaverPlaceActionSheet} hideTNPAS={() => this.props.hideTNPAS()} />
                        :
                        null
                }

                {
                    this.state.trafficConditionActionSheet.open ?
                        <TrafficConditionActionSheet list={this.state.trafficConditionActionSheet.list} hide={() => this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, open: false}})}/>
                        :
                        null
                }

                {
                    this.state.shareActionSheet.open ?
                        <ShareActionSheet open={this.state.shareActionSheet.open} target={TSAS.data} hide={() => this.setState({shareActionSheet: {...this.state.shareActionSheet, open: false}})}/>
                        :
                        null
                }
            </div>

        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
    showTutorial: (sort) => dispatch(showTutorial(sort)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TargetScheduleActionSheetFunctions))
